import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import SectionsHeading from "../../SectionsHeading";
import {
  AbsoluteImage,
  GradiantDiv,
  Image,
  OuterGradiantDiv,
  SecondGradiantDiv,
} from "../../../Styles/style";
import Paragraph from "../../Paragraph";

const GridWraper = styled(Grid)`
  width: 100%;
  height: 100%;
  display: flex;
  /* flex-direction:column; */
  justify-content: center;
  align-items: center;
  padding: 100px 0;
  column-gap: 20px;
`;
const ContinerWraper = styled(Container)`
  background: #050C24;
  height: auto;
  width: 100%;
  padding: 0 !important;
`;
const GridItem = styled(Grid)`
  margin: 30px 0;
  & .marginDiv {
    background: #070f29;
  }
  :hover {
    & .marginDiv {
      background: linear-gradient(to top, #fff, transparent);
    }
    & .shadow {
      filter: blur(10px);
    }
  }
`;
const FeatureSection = () => {
  return (
    <ContinerWraper maxWidth="xxl" id="features">
      <Container>
        <GridWraper container>
          <Grid item xs={12}>
            <SectionsHeading ta="center"  data-aos="zoom-in">Project Features</SectionsHeading>
          </Grid>
          <GridItem item xs={10} sm={6} md={3}  data-aos="fade-up" data-aos-duration="1000">
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv p="30px" p599="20px">
                  <div style={{ position: "relative", marginBottom: "5px" }}>
                    <Image
                      className="shadow"
                      w="30px"
                      src="./Images/launch.png"
                    />
                    <AbsoluteImage w="30px" src="./Images/launch.png" />
                  </div>
                  <Paragraph
                    ta="center"
                    fs="16px"
                    p="10px 0"
                    fs599="14px"
                    fm="PoppinsSB"
                  >
                    Stealth Launch
                  </Paragraph>
                  <Paragraph ta="center" fs599="12px">
                    Experience the thrill of a stealth launch, where Moonracer
                    takes off organically, setting the stage for a
                    groundbreaking journey.
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridItem item xs={10} sm={6} md={3}  data-aos="fade-up" data-aos-duration="1500">
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv p="30px" p599="20px">
                  <div style={{ position: "relative", marginBottom: "5px" }}>
                    <Image
                      className="shadow"
                      w="30px"
                      src="./Images/verified.png"
                    />
                    <AbsoluteImage w="30px" src="./Images/verified.png" />
                  </div>
                  <Paragraph
                    ta="center"
                    fs="16px"
                    p="10px 0"
                    fs599="14px"
                    fm="PoppinsSB"
                  >
                    Contract Verified
                  </Paragraph>
                  <Paragraph ta="center" fs599="12px">
                    Rest easy knowing that Moonracer's smart contract has been
                    meticulously verified, ensuring a secure and trustworthy
                    experience for all.
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
          <GridItem item xs={10} sm={6} md={3}  data-aos="fade-up" data-aos-duration="2000">
            <OuterGradiantDiv className="marginDiv">
              <SecondGradiantDiv>
                <GradiantDiv p="30px" p599="20px">
                  <div style={{ position: "relative", marginBottom: "5px" }}>
                    <Image
                      className="shadow"
                      w="30px"
                      src="./Images/lock.png"
                    />
                    <AbsoluteImage w="30px" src="./Images/lock.png" />
                  </div>
                  <Paragraph
                    ta="center"
                    fs="16px"
                    p="10px 0"
                    fs599="14px"
                    fm="PoppinsSB"
                  >
                    Liquidity Locked
                  </Paragraph>
                  <Paragraph ta="center" fs599="12px">
                    Our commitment to stability is unwavering. Moonracer's
                    liquidity is locked, providing confidence and reliability to
                    our valued community.
                  </Paragraph>
                </GradiantDiv>
              </SecondGradiantDiv>
            </OuterGradiantDiv>
          </GridItem>
        </GridWraper>
      </Container>
    </ContinerWraper>
  );
};

export default FeatureSection;
